
import React from "react";
import ToDoApi from "../API/ToDoApi";

import {
    TaskRow as Row,
    TaskPhoto,
    TaskInfo,
    Comment,
    Info,
    PhotoList,
    SmallPhoto,
    StatusButton,
    Button,
    HouseTag,
    CompletionNote
} from "./design";

function formatDate(date) {
    if (!date) return "";

    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(
        String(date)
    );

    return match
        ? `${match[3]}.${match[2]}.${match[1]}`
        : String(date);
}

const TaskRow = ({
                     task,
                     busy,
                     onPreview,
                     onStatusChange,
                     onDelete,
                     onOpen
                 }) => {
    const photos = task.photos ?? [];
    const afterPhotos = task.completionPhotos ?? [];

    const firstPhoto = photos[0];

    return (
        <Row
            role="button"
            tabIndex={0}
            onClick={() => onOpen(task)}
            onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onOpen(task);
                }
            }}
            style={{ cursor: "pointer" }}
        >
            {firstPhoto ? (
                <TaskPhoto
                    src={ToDoApi.getPhotoUrl(firstPhoto)}
                    alt="Vorher"
                    onClick={(e) => {
                        e.stopPropagation();
                        onPreview(
                            ToDoApi.getPhotoUrl(firstPhoto)
                        );
                    }}
                />
            ) : (
                <div style={{
                    width: 85,
                    height: 85,
                    flexShrink: 0,
                    background: "#f1f5f9",
                    borderRadius: 8
                }}/>
            )}

            <TaskInfo>
                <Comment>
                    {task.comment}
                </Comment>

                <Info>
                    Von: {task.author}
                </Info>

                <Info>
                    {formatDate(task.date)}

                    <HouseTag>
                        {task.house}
                    </HouseTag>
                    {task.floor && (
                        <HouseTag>{task.floor}</HouseTag>
                    )}
                </Info>

                {task.completedAt && (
                    <Info>
                        Erledigt am: {
                        formatDate(task.completedAt)
                    }
                    </Info>
                )}

                {task.completed && task.completionComment && (
                    <CompletionNote>
                        <strong>Erledigung:</strong>{" "}
                        {task.completionComment}
                    </CompletionNote>
                )}

                <PhotoList>
                    {photos.map(photo => (
                        <SmallPhoto
                            key={photo.id}
                            src={ToDoApi.getPhotoUrl(photo)}
                            alt="Vorher"
                            title="Vorher"
                            onClick={() =>
                                onPreview(
                                    ToDoApi.getPhotoUrl(photo)
                                )
                            }
                        />
                    ))}

                    {afterPhotos.map(photo => (
                        <SmallPhoto
                            key={photo.id}
                            src={ToDoApi.getPhotoUrl(photo)}
                            alt="Nachher"
                            title="Nachher"
                            style={{
                                border: "2px solid #019A32"
                            }}
                            onClick={(e) =>{
                                e.stopPropagation();
                                onPreview(
                                    ToDoApi.getPhotoUrl(photo)
                                )
                            }}
                        />
                    ))}
                </PhotoList>
            </TaskInfo>

            <StatusButton
                type="button"
                $done={task.completed}
                disabled={busy}
                onClick={(e) => {
                    e.stopPropagation();
                    onStatusChange(task)
                }}
            >
                {task.completed
                    ? "✓ Erledigt"
                    : "○ Offen"}
            </StatusButton>

            <Button
                type="button"
                $secondary
                disabled={busy}
                onClick={(e) => {
                    e.stopPropagation();
                    onDelete(task)
                }}
                title="Aufgabe löschen"
            >
                ×
            </Button>
        </Row>
    );
};

export default TaskRow;
